// ============================ Login ======================================

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

// ============================ Forgot Password ======================================

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

// ============================ Reset Password ======================================

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

// ============================ Change Password ======================================

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

// ============================ Update Password ======================================

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";

// ============================ OTP ======================================

export const OTP = "OTP";
export const OTP_SUCCESS = "OTP_SUCCESS";
export const OTP_FAILURE = "OTP_FAILURE";

// ============================ GET_HOME ======================================

export const GET_HOME = "GET_HOME";
export const GET_HOME_SUCCESS = "GET_HOME_SUCCESS";
export const GET_HOME_FAILURE = "GET_HOME_FAILURE";

// ============================ HOME_STATUS ======================================

export const UPDATE_HOME_STATUS = "UPDATE_HOME_STATUS";
export const UPDATE_HOME_STATUS_SUCCESS = "UPDATE_HOME_STATUS_SUCCESS";
export const UPDATE_HOME_STATUS_FAILURE = "UPDATE_HOME_STATUS_FAILURE";

// ============================ HOME_ORDER_STATUS ======================================

export const UPDATE_HOME_ORDER_STATUS = "UPDATE_HOME_ORDER_STATUS";
export const UPDATE_HOME_ORDER_STATUS_SUCCESS =
  "UPDATE_HOME_ORDER_STATUS_SUCCESS";
export const UPDATE_HOME_ORDER_STATUS_FAILURE =
  "UPDATE_HOME_ORDER_STATUS_FAILURE";

// ============================ ADD_HOME ======================================

export const ADD_HOME = "ADD_HOME";
export const ADD_HOME_SUCCESS = "ADD_HOME_SUCCESS";
export const ADD_HOME_FAILURE = "ADD_HOME_FAILURE";

// ============================ EDIT_HOME ======================================

export const EDIT_HOME = "EDIT_HOME";
export const EDIT_HOME_SUCCESS = "EDIT_HOME_SUCCESS";
export const EDIT_HOME_FAILURE = "EDIT_HOME_FAILURE";

// ============================ DELETE_HOME ======================================

export const DELETE_HOME = "DELETE_HOME";
export const DELETE_HOME_SUCCESS = "DELETE_HOME_SUCCESS";
export const DELETE_HOME_FAILURE = "DELETE_HOME_FAILURE";

// ============================ GET_THEME ======================================

export const GET_THEME = "GET_THEME";
export const GET_THEME_SUCCESS = "GET_THEME_SUCCESS";
export const GET_THEME_FAILURE = "GET_THEME_FAILURE";

// ============================ UPDATE_THEME_STATUS ======================================

export const UPDATE_THEME_STATUS = "UPDATE_THEME_STATUS";
export const UPDATE_THEME_STATUS_SUCCESS = "UPDATE_THEME_STATUS_SUCCESS";
export const UPDATE_THEME_STATUS_FAILURE = "UPDATE_THEME_STATUS_FAILURE";

// ============================ EDIT_THEME ======================================

export const EDIT_THEME = "EDIT_THEME";
export const EDIT_THEME_SUCCESS = "EDIT_THEME_SUCCESS";
export const EDIT_THEME_FAILURE = "EDIT_THEME_FAILURE";

// ============================ THEME_LISTING ======================================

export const THEMES_LIST = "THEME_LIST";
export const THEMES_LIST_SUCCESS = "THEMES_LIST_SUCCESS";
export const THEMES_LIST_FAILURE = "THEMES_LIST_FAILURE";

// ============================ ADD_THEME ======================================

export const ADD_THEME = "ADD_THEME";
export const ADD_THEME_SUCCESS = "ADD_THEME_SUCCESS";
export const ADD_THEME_FAILURE = "ADD_THEME_FAILURE";

// ============================ THEME_ORDER_STATUS ======================================

export const UPDATE_THEME_ORDER_STATUS = "UPDATE_THEME_ORDER_STATUS";
export const UPDATE_THEME_ORDER_STATUS_SUCCESS =
  "UPDATE_THEME_ORDER_STATUS_SUCCESS";
export const UPDATE_THEME_ORDER_STATUS_FAILURE =
  "UPDATE_THEME_ORDER_STATUS_FAILURE";

// ============================ DELETE_THEME ======================================

export const DELETE_THEME = "DELETE_THEME";
export const DELETE_THEME_SUCCESS = "DELETE_THEME_SUCCESS";
export const DELETE_THEME_FAILURE = "DELETE_THEME_FAILURE";

// ============================ GET_USER ======================================

export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";

// ============================ DELETE_USER ======================================

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

// ============================ ADD_USER ======================================

export const ADD_USER = "ADD_USER";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "ADD_USER_FAILURE";

// ============================ EDIT_USER ======================================

export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAILURE = "EDIT_USER_FAILURE";

// ============================ UPDATE_USER_STATUS ======================================

export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAILURE = "UPDATE_USER_STATUS_FAILURE";

// ============================ IMPORT_USER_DATA ======================================

export const IMPORT_USER_DATA = "IMPORT_USER_DATA";
export const IMPORT_USER_DATA_SUCCESS = "IMPORT_USER_DATA_SUCCESS";
export const IMPORT_USER_DATA_FAILURE = "IMPORT_USER_DATA_FAILURE";

// ============================ GET_ZIP ======================================

export const GET_ZIP = "GET_ZIP";
export const GET_ZIP_SUCCESS = "GET_ZIP_SUCCESS";
export const GET_ZIP_FAILURE = "GET_ZIP_FAILURE";

// ============================ ZIP_STATUS ======================================

export const UPDATE_ZIP_STATUS = "UPDATE_ZIP_STATUS";
export const UPDATE_ZIP_STATUS_SUCCESS = "UPDATE_ZIP_STATUS_SUCCESS";
export const UPDATE_ZIP_STATUS_FAILURE = "UPDATE_ZIP_STATUS_FAILURE";

// ============================ ADD_ZIP ======================================

export const ADD_ZIP = "ADD_ZIP";
export const ADD_ZIP_SUCCESS = "ADD_ZIP_SUCCESS";
export const ADD_ZIP_FAILURE = "ADD_ZIP_FAILURE";

// ============================ EDIT_ZIP ======================================

export const EDIT_ZIP = "EDIT_ZIP";
export const EDIT_ZIP_SUCCESS = "EDIT_ZIP_SUCCESS";
export const EDIT_ZIP_FAILURE = "EDIT_ZIP_FAILURE";

// ============================ DELETE_ZIP ======================================

export const DELETE_ZIP = "DELETE_ZIP";
export const DELETE_ZIP_SUCCESS = "DELETE_ZIP_SUCCESS";
export const DELETE_ZIP_FAILURE = "DELETE_ZIP_FAILURE";

// ============================ GET_STATES ======================================

export const GET_STATES = "GET_STATES";
export const GET_STATES_SUCCESS = "GET_STATES_SUCCESS";
export const GET_STATES_FAILURE = "GET_STATES_FAILURE";

// ============================ IMPORT_USER_DATA ======================================

export const IMPORT_ZIP_DATA = "IMPORT_ZIP_DATA";
export const IMPORT_ZIP_DATA_SUCCESS = "IMPORT_ZIP_DATA_SUCCESS";
export const IMPORT_ZIP_DATA_FAILURE = "IMPORT_ZIP_DATA_FAILURE";

// ============================ GET_PRODUCT ======================================

export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAILURE = "GET_PRODUCT_FAILURE";

// ============================ PRODUCT_STATUS ======================================

export const UPDATE_PRODUCT_STATUS = "UPDATE_PRODUCT_STATUS";
export const UPDATE_PRODUCT_STATUS_SUCCESS = "UPDATE_PRODUCT_STATUS_SUCCESS";
export const UPDATE_PRODUCT_STATUS_FAILURE = "UPDATE_PRODUCT_STATUS_FAILURE";

// ============================ ADD_PRODUCT ======================================

export const ADD_PRODUCT = "ADD_PRODUCT";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAILURE = "ADD_PRODUCT_FAILURE";

// ============================ EDIT_PRODUCT ======================================

export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILURE = "EDIT_PRODUCT_FAILURE";

// ============================ DELETE_PRODUCT ======================================

export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

// ============================ PRODUCT_ORDER_STATUS ======================================

export const UPDATE_PRODUCT_ORDER_STATUS = "UPDATE_PRODUCT_ORDER_STATUS";
export const UPDATE_PRODUCT_ORDER_STATUS_SUCCESS =
  "UPDATE_PRODUCT_ORDER_STATUS_SUCCESS";
export const UPDATE_PRODUCT_ORDER_STATUS_FAILURE =
  "UPDATE_PRODUCT_ORDER_STATUS_FAILURE";

// ============================ GET_VIDEOS ======================================

export const GET_VIDEOS = "GET_VIDEOS";
export const GET_VIDEOS_SUCCESS = "GET_VIDEOS_SUCCESS";
export const GET_VIDEOS_FAILURE = "GET_VIDEOS_FAILURE";

// ============================ UPDATE_VIDEOS_STATUS ======================================

export const UPDATE_VIDEOS_STATUS = "UPDATE_VIDEOS_STATUS";
export const UPDATE_VIDEOS_STATUS_SUCCESS = "UPDATE_VIDEOS_STATUS_SUCCESS";
export const UPDATE_VIDEOS_STATUS_FAILURE = "UPDATE_VIDEOS_STATUS_FAILURE";

// ============================ UPDATE_VIDEOS_ORDER_STATUS ======================================

export const UPDATE_VIDEO_ORDER_STATUS = "UPDATE_VIDEO_ORDER_STATUS";
export const UPDATE_VIDEO_ORDER_STATUS_SUCCESS =
  "UPDATE_VIDEO_ORDER_STATUS_SUCCESS";
export const UPDATE_VIDEO_ORDER_STATUS_FAILURE =
  "UPDATE_VIDEO_ORDER_STATUS_FAILURE";

// ============================ DELETE_VIDEOS ======================================

export const DELETE_VIDEOS = "DELETE_VIDEOS";
export const DELETE_VIDEOS_SUCCESS = "DELETE_VIDEOS_SUCCESS";
export const DELETE_VIDEOS_FAILURE = "DELETE_VIDEOS_FAILURE";

// ============================ ADD_VIDEO ======================================

export const ADD_VIDEO = "ADD_VIDEO";
export const ADD_VIDEO_SUCCESS = "ADD_VIDEO_SUCCESS";
export const ADD_VIDEO_FAILURE = "ADD_VIDEO_FAILURE";

// ============================ EDIT_VIDEO ======================================

export const EDIT_VIDEO = "EDIT_VIDEO";
export const EDIT_VIDEO_SUCCESS = "EDIT_VIDEO_SUCCESS";
export const EDIT_VIDEO_FAILURE = "EDIT_VIDEO_FAILURE";

// ============================ GET_ADMINS ======================================

export const GET_ADMINS = "GET_ADMINS";
export const GET_ADMINS_SUCCESS = "GET_ADMINS_SUCCESS";
export const GET_ADMINS_FAILURE = "GET_ADMINS_FAILURE";

// ============================ GET_MODULES ======================================

export const GET_MODULES = "GET_MODULES";
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_FAILURE = "GET_MODULES_FAILURE";

// ============================ UPDATE_ADMIN_STATUS ======================================

export const UPDATE_ADMIN_STATUS = "UPDATE_ADMIN_STATUS";
export const UPDATE_ADMIN_STATUS_SUCCESS = "UPDATE_ADMIN_STATUS_SUCCESS";
export const UPDATE_ADMIN_STATUS_FAILURE = "UPDATE_ADMIN_STATUS_FAILURE";

// ============================ DELETE_ADMIN ======================================

export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_FAILURE = "DELETE_ADMIN_FAILURE";

// ============================ ADD_ADMIN ======================================

export const ADD_ADMIN = "ADD_ADMIN";
export const ADD_ADMIN_SUCCESS = "ADD_ADMIN_SUCCESS";
export const ADD_ADMIN_FAILURE = "ADD_ADMIN_FAILURE";

// ============================ EDIT_ADMIN ======================================

export const EDIT_ADMIN = "EDIT_ADMIN";
export const EDIT_ADMIN_SUCCESS = "EDIT_ADMIN_SUCCESS";
export const EDIT_ADMIN_FAILURE = "EDIT_ADMIN_FAILURE";

// ============================ RESET_PASSWORD_ADMIN ======================================

export const RESET_PASSWORD_ADMIN = "RESET_PASSWORD_ADMIN";
export const RESET_PASSWORD_ADMIN_SUCCESS = "RESET_PASSWORD_ADMIN_SUCCESS";
export const RESET_PASSWORD_ADMIN_FAILURE = "RESET_PASSWORD_ADMIN_FAILURE";

// ============================ GET_QUESTIONS ======================================

export const GET_QUESTIONS = "GET_QUESTIONS";
export const GET_QUESTIONS_SUCCESS = "GET_QUESTIONS_SUCCESS";
export const GET_QUESTIONS_FAILURE = "GET_QUESTIONS_FAILURE";

// ============================ UPDATE_QUESTION_STATUS ======================================

export const UPDATE_QUESTION_STATUS = "UPDATE_QUESTION_STATUS";
export const UPDATE_QUESTION_STATUS_SUCCESS = "UPDATE_QUESTION_STATUS_SUCCESS";
export const UPDATE_QUESTION_STATUS_FAILURE = "UPDATE_QUESTION_STATUS_FAILURE";

// ============================ DELETE_QUESTION ======================================

export const DELETE_QUESTION = "DELETE_QUESTION";
export const DELETE_QUESTION_SUCCESS = "DELETE_QUESTION_SUCCESS";
export const DELETE_QUESTION_FAILURE = "DELETE_QUESTION_FAILURE";

// ============================ ADD_QUESTION ======================================

export const ADD_QUESTION = "ADD_QUESTION";
export const ADD_QUESTION_SUCCESS = "ADD_QUESTION_SUCCESS";
export const ADD_QUESTION_FAILURE = "ADD_QUESTION_FAILURE";

// ============================ EDIT_QUESTION ======================================

export const EDIT_QUESTION = "EDIT_QUESTION";
export const EDIT_QUESTION_SUCCESS = "EDIT_QUESTION_SUCCESS";
export const EDIT_QUESTION_FAILURE = "EDIT_QUESTION_FAILURE";

// ============================ GET_QUESTION_DETAILS ======================================

export const GET_QUESTION_DETAILS = "GET_QUESTION_DETAILS";
export const GET_QUESTION_DETAILS_SUCCESS = "GET_QUESTION_DETAILS_SUCCESS";
export const GET_QUESTION_DETAILS_FAILURE = "GET_QUESTION_DETAILS_FAILURE";

// ============================ IMPORT_QUESTIONS ======================================

export const IMPORT_QUESTIONS_DATA = "IMPORT_QUESTIONS_DATA";
export const IMPORT_QUESTIONS_DATA_SUCCESS = "IMPORT_QUESTIONS_DATA_SUCCESS";
export const IMPORT_QUESTIONS_DATA_FAILURE = "IMPORT_QUESTIONS_DATA_FAILURE";

// ============================ ADD_MOBILE_CONFIGURATION ======================================

export const ADD_MOBILE_CONFIGURATION = "ADD_MOBILE_CONFIGURATION";
export const ADD_MOBILE_CONFIGURATION_SUCCESS =
  "ADD_MOBILE_CONFIGURATION_SUCCESS";
export const ADD_MOBILE_CONFIGURATION_FAILURE =
  "ADD_MOBILE_CONFIGURATION_FAILURE";

// ============================ GET_MOBILE_CONFIGURATION ======================================

export const GET_MOBILE_CONFIGURATION = "GET_MOBILE_CONFIGURATION";
export const GET_MOBILE_CONFIGURATION_SUCCESS =
  "GET_MOBILE_CONFIGURATION_SUCCESS";
export const GET_MOBILE_CONFIGURATION_FAILURE =
  "GET_MOBILE_CONFIGURATION_FAILURE";

// ============================ GET_CONTACTS ======================================

export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONTACTS_SUCCESS = "GET_CONTACTS_SUCCESS";
export const GET_CONTACTS_FAILURE = "GET_CONTACTS_FAILURE";

// ============================ UPDATE_CONTACT_STATUS ======================================

export const UPDATE_CONTACT_STATUS = "UPDATE_CONTACT_STATUS";
export const UPDATE_CONTACT_STATUS_SUCCESS = "UPDATE_CONTACT_STATUS_SUCCESS";
export const UPDATE_CONTACT_STATUS_FAILURE = "UPDATE_CONTACT_STATUS_FAILURE";

// ============================ ADD_CONTACT ======================================

export const ADD_CONTACT = "ADD_CONTACT";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAILURE = "ADD_CONTACT_FAILURE";

// ============================ EDIT_CONTACT ======================================

export const EDIT_CONTACT = "EDIT_CONTACT";
export const EDIT_CONTACT_SUCCESS = "EDIT_CONTACT_SUCCESS";
export const EDIT_CONTACT_FAILURE = "EDIT_CONTACT_FAILURE";

// ============================ DELETE_CONTACT ======================================

export const DELETE_CONTACT = "DELETE_CONTACT";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";
export const DELETE_CONTACT_FAILURE = "DELETE_CONTACT_FAILURE";

// ============================ CONTACT_ORDER_STATUS ======================================

export const UPDATE_CONTACT_ORDER_STATUS = "UPDATE_CONTACT_ORDER_STATUS";
export const UPDATE_CONTACT_ORDER_STATUS_SUCCESS =
  "UPDATE_CONTACT_ORDER_STATUS_SUCCESS";
export const UPDATE_CONTACT_ORDER_STATUS_FAILURE =
  "UPDATE_CONTACT_ORDER_STATUS_FAILURE";

// ============================ GET_SERVICES ======================================

export const GET_SERVICES = "GET_SERVICES";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";

// ============================ UPDATE_SERVICE_STATUS ======================================

export const UPDATE_SERVICE_STATUS = "UPDATE_SERVICE_STATUS";
export const UPDATE_SERVICE_STATUS_SUCCESS = "UPDATE_SERVICE_STATUS_SUCCESS";
export const UPDATE_SERVICE_STATUS_FAILURE = "UPDATE_SERVICE_STATUS_FAILURE";

// ============================ DELETE_SERVICE ======================================

export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAILURE = "DELETE_SERVICE_FAILURE";

// ============================ ADD_SERVICE ======================================

export const ADD_SERVICE = "ADD_SERVICE";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAILURE = "ADD_SERVICE_FAILURE";
export const RESET_ADD_SERVICE_DATA = "RESET_ADD_SERVICE_DATA";

// ============================ EDIT_SERVICE ======================================

export const EDIT_SERVICE = "EDIT_SERVICE";
export const EDIT_SERVICE_SUCCESS = "EDIT_SERVICE_SUCCESS";
export const EDIT_SERVICE_FAILURE = "EDIT_SERVICE_FAILURE";

// ============================ SERVICE_DETAILS ======================================

export const SERVICE_DETAILS = "SERVICE_DETAILS";
export const SERVICE_DETAILS_SUCCESS = "SERVICE_DETAILS_SUCCESS";
export const SERVICE_DETAILS_FAILURE = "SERVICE_DETAILS_FAILURE";

// ============================ QUESTION_DROPDOWN_LIST ======================================

export const QUESTION_DROPDOWN_LIST = "QUESTION_DROPDOWN_LIST";
export const QUESTION_DROPDOWN_LIST_SUCCESS = "QUESTION_DROPDOWN_LIST_SUCCESS";
export const QUESTION_DROPDOWN_LIST_FAILURE = "QUESTION_DROPDOWN_LIST_FAILURE";

// ============================ SERVICE_ORDER_STATUS ======================================

export const UPDATE_SERVICES_ORDER_STATUS = "UPDATE_SERVICES_ORDER_STATUS";
export const UPDATE_SERVICES_ORDER_STATUS_SUCCESS =
  "UPDATE_SERVICES_ORDER_STATUS_SUCCESS";
export const UPDATE_SERVICES_ORDER_STATUS_FAILURE =
  "UPDATE_SERVICES_ORDER_STATUS_FAILURE";

// ============================ GET_SETTINGS ======================================

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE";

// ============================ UPDATE_SETTING_STATUS ======================================

export const UPDATE_SETTING_STATUS = "UPDATE_SETTING_STATUS";
export const UPDATE_SETTING_STATUS_SUCCESS = "UPDATE_SETTING_STATUS_SUCCESS";
export const UPDATE_SETTING_STATUS_FAILURE = "UPDATE_SETTING_STATUS_FAILURE";

// ============================ DELETE_SETTING ======================================

export const DELETE_SETTING = "DELETE_SETTING";
export const DELETE_SETTING_SUCCESS = "DELETE_SETTING_SUCCESS";
export const DELETE_SETTING_FAILURE = "DELETE_SETTING_FAILURE";

// ============================ ADD_SETTING ======================================

export const ADD_SETTING = "ADD_SETTING";
export const ADD_SETTING_SUCCESS = "ADD_SETTING_SUCCESS";
export const ADD_SETTING_FAILURE = "ADD_SETTING_FAILURE";

// ============================ EDIT_SETTING ======================================

export const EDIT_SETTING = "EDIT_SETTING";
export const EDIT_SETTING_SUCCESS = "EDIT_SETTING_SUCCESS";
export const EDIT_SETTING_FAILURE = "EDIT_SETTING_FAILURE";

// ============================ SETTING_ORDER_STATUS ======================================

export const UPDATE_SETTINGS_ORDER_STATUS = "UPDATE_SETTINGS_ORDER_STATUS";
export const UPDATE_SETTINGS_ORDER_STATUS_SUCCESS =
  "UPDATE_SETTINGS_ORDER_STATUS_SUCCESS";
export const UPDATE_SETTINGS_ORDER_STATUS_FAILURE =
  "UPDATE_SETTINGS_ORDER_STATUS_FAILURE";

// ============================ GET_HELP ======================================

export const GET_HELP = "GET_HELP";
export const GET_HELP_SUCCESS = "GET_HELP_SUCCESS";
export const GET_HELP_FAILURE = "GET_HELP_FAILURE";

// ============================ UPDATE_HELP_STATUS ======================================

export const UPDATE_HELP_STATUS = "UPDATE_HELP_STATUS";
export const UPDATE_HELP_STATUS_SUCCESS = "UPDATE_HELP_STATUS_SUCCESS";
export const UPDATE_HELP_STATUS_FAILURE = "UPDATE_HELP_STATUS_FAILURE";

// ============================ ADD_HELP ======================================

export const ADD_HELP = "ADD_HELP";
export const ADD_HELP_SUCCESS = "ADD_HELP_SUCCESS";
export const ADD_HELP_FAILURE = "ADD_HELP_FAILURE";

// ============================ EDIT_HELP ======================================

export const EDIT_HELP = "EDIT_HELP";
export const EDIT_HELP_SUCCESS = "EDIT_HELP_SUCCESS";
export const EDIT_HELP_FAILURE = "EDIT_HELP_FAILURE";

// ============================ DELETE_HELP ======================================

export const DELETE_HELP = "DELETE_HELP";
export const DELETE_HELP_SUCCESS = "DELETE_HELP_SUCCESS";
export const DELETE_HELP_FAILURE = "DELETE_HELP_FAILURE";

// ============================ GET_HELP_DETAILS ======================================

export const GET_HELP_DETAILS = "GET_HELP_DETAILS";
export const GET_HELP_DETAILS_SUCCESS = "GET_HELP_DETAILS_SUCCESS";
export const GET_HELP_DETAILS_FAILURE = "GET_HELP_DETAILS_FAILURE";

// ============================ GET_SERVICE_REQUEST ======================================

export const GET_SERVICE_REQUEST = "GET_SERVICE_REQUEST";
export const GET_SERVICE_REQUEST_SUCCESS = "GET_SERVICE_REQUEST_SUCCESS";
export const GET_SERVICE_REQUEST_FAILURE = "GET_SERVICE_REQUEST_FAILURE";

// ============================ SERVICE_REQUEST_DETAILS ======================================

export const SERVICE_REQUEST_DETAILS = "SERVICE_REQUEST_DETAILS";
export const SERVICE_REQUEST_DETAILS_SUCCESS =
  "SERVICE_REQUEST_DETAILS_SUCCESS";
export const SERVICE_REQUEST_DETAILS_FAILURE =
  "SERVICE_REQUEST_DETAILS_FAILURE";

// ============================ HELP_ORDER_STATUS ======================================

export const UPDATE_HELP_ORDER_STATUS = "UPDATE_HELP_ORDER_STATUS";
export const UPDATE_HELP_ORDER_STATUS_SUCCESS =
  "UPDATE_HELP_ORDER_STATUS_SUCCESS";
export const UPDATE_HELP_ORDER_STATUS_FAILURE =
  "UPDATE_HELP_ORDER_STATUS_FAILURE";

// ============================ REGISTRATION ======================================

export const REGISTRATION = "REGISTRATION";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_FAILURE = "REGISTRATION_FAILURE";

// ============================ EDIT_REGISTRATION ======================================

export const EDIT_REGISTRATION = "EDIT_REGISTRATION";
export const EDIT_REGISTRATION_SUCCESS = "EDIT_REGISTRATION_SUCCESS";
export const EDIT_REGISTRATION_FAILURE = "EDIT_REGISTRATION_FAILURE";

// ============================ USER SERVICES ======================================

export const GET_USER_SERVICES = "GET_USER_SERVICES";
export const GET_USER_SERVICES_SUCCESS = "GET_USER_SERVICES_SUCCESS";
export const GET_USER_SERVICES_FAILURE = "GET_USER_SERVICES_FAILURE";

// ============================ DOWNLOAD USERS ======================================

export const DOWNLOAD_SERVICE_REQUEST = "DOWNLOAD_SERVICE_REQUEST";
export const DOWNLOAD_SERVICE_REQUEST_SUCCESS =
  "DOWNLOAD_SERVICE_REQUEST_SUCCESS";
export const DOWNLOAD_SERVICE_REQUEST_FAILURE =
  "DOWNLOAD_SERVICE_REQUEST_FAILURE";

// ============================ DOWNLOAD CSV USERS ======================================

export const DOWNLOAD_CSV_USERS = "DOWNLOAD_CSV_USERS";
export const DOWNLOAD_CSV_USERS_SUCCESS = "DOWNLOAD_CSV_USERS_SUCCESS";
export const DOWNLOAD_CSV_USERS_FAILURE = "DOWNLOAD_CSV_USERS_FAILURE";

// ============================ GET_BANKS ======================================

export const GET_BANK = "GET_BANK";
export const GET_BANK_SUCCESS = "GET_BANK_SUCCESS";
export const GET_BANK_FAILURE = "GET_BANK_FAILURE";

// ============================ UPDATE_BANK_STATUS ======================================

export const UPDATE_BANK_STATUS = "UPDATE_BANK_STATUS";
export const UPDATE_BANK_STATUS_SUCCESS = "UPDATE_BANK_STATUS_SUCCESS";
export const UPDATE_BANK_STATUS_FAILURE = "UPDATE_BANK_STATUS_FAILURE";

// ============================ DELETE_BANK ======================================

export const DELETE_BANK = "DELETE_BANK";
export const DELETE_BANK_SUCCESS = "DELETE_BANK_SUCCESS";
export const DELETE_BANK_FAILURE = "DELETE_BANK_FAILURE";

// ============================ EDIT_BANK ======================================

export const EDIT_BANK = "EDIT_BANK";
export const EDIT_BANK_SUCCESS = "EDIT_BANK_SUCCESS";
export const EDIT_BANK_FAILURE = "EDIT_BANK_FAILURE";

// ============================ ADD_BANK ======================================

export const ADD_BANK = "ADD_BANK";
export const ADD_BANK_SUCCESS = "ADD_BANK_SUCCESS";
export const ADD_BANK_FAILURE = "ADD_BANK_FAILURE";

// ============================ COPY_BANK ======================================

export const COPY_BANK = "COPY_BANK";
export const COPY_BANK_SUCCESS = "COPY_BANK_SUCCESS";
export const COPY_BANK_FAILURE = "COPY_BANK_FAILURE";

// ============================ GET_HOLIDAYS ======================================

export const GET_HOLIDAY = "GET_HOLIDAY";
export const GET_HOLIDAY_SUCCESS = "GET_HOLIDAY_SUCCESS";
export const GET_HOLIDAY_FAILURE = "GET_HOLIDAY_FAILURE";

// ============================ UPDATE_HOLIDAY_STATUS ======================================

export const UPDATE_HOLIDAY_STATUS = "UPDATE_HOLIDAY_STATUS";
export const UPDATE_HOLIDAY_STATUS_SUCCESS = "UPDATE_HOLIDAY_STATUS_SUCCESS";
export const UPDATE_HOLIDAY_STATUS_FAILURE = "UPDATE_HOLIDAY_STATUS_FAILURE";

// ============================ DELETE_HOLIDAY ======================================

export const DELETE_HOLIDAY = "DELETE_HOLIDAY";
export const DELETE_HOLIDAY_SUCCESS = "DELETE_HOLIDAY_SUCCESS";
export const DELETE_HOLIDAY_FAILURE = "DELETE_HOLIDAY_FAILURE";

// ============================ EDIT_HOLIDAY ======================================

export const EDIT_HOLIDAY = "EDIT_HOLIDAY";
export const EDIT_HOLIDAY_SUCCESS = "EDIT_HOLIDAY_SUCCESS";
export const EDIT_HOLIDAY_FAILURE = "EDIT_HOLIDAY_FAILURE";

// ============================ ADD_HOLIDAY ======================================

export const ADD_HOLIDAY = "ADD_HOLIDAY";
export const ADD_HOLIDAY_SUCCESS = "ADD_HOLIDAY_SUCCESS";
export const ADD_HOLIDAY_FAILURE = "ADD_HOLIDAY_FAILURE";

// ============================ GET_ANNOUNCEMENTS ======================================

export const GET_ANNOUNCEMENT = "GET_ANNOUNCEMENT";
export const GET_ANNOUNCEMENT_SUCCESS = "GET_ANNOUNCEMENT_SUCCESS";
export const GET_ANNOUNCEMENT_FAILURE = "GET_ANNOUNCEMENT_FAILURE";

// ============================ UPDATE_ANNOUNCEMENT_STATUS ======================================

export const UPDATE_ANNOUNCEMENT_STATUS = "UPDATE_ANNOUNCEMENT_STATUS";
export const UPDATE_ANNOUNCEMENT_STATUS_SUCCESS = "UPDATE_ANNOUNCEMENT_STATUS_SUCCESS";
export const UPDATE_ANNOUNCEMENT_STATUS_FAILURE = "UPDATE_ANNOUNCEMENT_STATUS_FAILURE";

// ============================ DELETE_ANNOUNCEMENT ======================================

export const DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT";
export const DELETE_ANNOUNCEMENT_SUCCESS = "DELETE_ANNOUNCEMENT_SUCCESS";
export const DELETE_ANNOUNCEMENT_FAILURE = "DELETE_ANNOUNCEMENT_FAILURE";

// ============================ EDIT_ANNOUNCEMENT ======================================

export const EDIT_ANNOUNCEMENT = "EDIT_ANNOUNCEMENT";
export const EDIT_ANNOUNCEMENT_SUCCESS = "EDIT_ANNOUNCEMENT_SUCCESS";
export const EDIT_ANNOUNCEMENT_FAILURE = "EDIT_ANNOUNCEMENT_FAILURE";

// ============================ ADD_ANNOUNCEMENT ======================================

export const ADD_ANNOUNCEMENT = "ADD_ANNOUNCEMENT";
export const ADD_ANNOUNCEMENT_SUCCESS = "ADD_ANNOUNCEMENT_SUCCESS";
export const ADD_ANNOUNCEMENT_FAILURE = "ADD_ANNOUNCEMENT_FAILURE";